<template>
    <div 
        v-if="scriptLoaded"
        @click="openChooser"
        class="af-dropbox-picker"
    >
        {{ $t('resume.dropbox_title') }}
    </div>
</template>

<script>
    export default {
        name: 'DropboxPicker',

        data() {
            return {
                apiKey: process.env.VUE_APP_DROPBOX_API_KEY,
                linkType: 'direct',
                multiselect: false,
                extensions: ['.pdf','.docx','.doc'],
                folderselect: false,
                sizeLimit: 2000000,
                scriptLoaded: false,
                dropboxChooserIsSupported: false,
            };
        },

        mounted() {
            if (window.Dropbox) {
                this.scriptLoaded = true;
            } else {
                const dropBoxScript = document.createElement('script');
                dropBoxScript.onload = () => {
                    this.scriptLoaded = true;
                    this.dropboxChooserIsSupported = window.Dropbox.isBrowserSupported();

                    if (!this.dropboxChooserIsSupported) {
                        console.warn('VueDropboxPicker: This browser is not supported');
                    }
                };
                dropBoxScript.setAttribute('src', 'https://www.dropbox.com/static/api/2/dropins.js');
                dropBoxScript.setAttribute('id', 'dropboxjs');
                dropBoxScript.setAttribute('data-app-key', this.apiKey);
                document.head.appendChild(dropBoxScript);
            }
        },

        methods: {  
            openChooser() {
                const options = {
                    multiselect: this.multiselect,
                    folderselect: this.folderselect,
                    linkType: this.linkType,
                    success: (files) => {
                        this.$emit('picked', files);
                    },
                    cancel: () => {
                        this.$emit('cancel');
                    },
                };

                if (this.extensions.length) {
                    options.extensions = this.extensions;
                }

                if (this.sizeLimit) {
                    options.sizeLimit = this.sizeLimit;
                }

                window.Dropbox.choose(options);
            },
        },
    };
</script>

